/* eslint-disable no-undef */
import { Common, color } from '@stockbit/ui';
import Link from 'next/link';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import Image from 'global/Image';
import { effects as profileEffects } from 'lib/entities/profile';
import auth from 'utils/auth';
import { SUCCESS_CONTENT } from '../constants';

const { Button, Flex, Text } = Common;

interface SuccessCardProps {
  type: 'email' | 'password' | 'phone';
  backLink: string;
}

function SuccessCard({ type, backLink }: SuccessCardProps) {
  const dispatch = useDispatch();

  useEffect(() => {
    // @ts-ignore
    const { username } = auth.getUserAccess();

    // @ts-ignore
    dispatch(profileEffects.getUserProfile(username));
  }, []);

  return (
    <Flex direction="column" width="100%" justify="center" align="center">
      <Image src="/icon/previewOrder-success.svg" alt="success" />
      <Text family="bold" size="22px" mt="20px" data-cy="success-card-text">
        Berhasil
      </Text>
      <Text>{SUCCESS_CONTENT[type.toUpperCase()]}</Text>
      <Link href={backLink}>
        <Button
          type="primary"
          mt="20px"
          mb="50px"
          width="80px"
          data-cy="succes-card-ok-button"
        >
          <Text family="bold" my="px" color={color.light}>
            Oke
          </Text>
        </Button>
      </Link>
    </Flex>
  );
}

export default SuccessCard;
